import { Component, Inject, OnInit } from '@angular/core';
import { ExecutionQTestInstrumentalUsed, ExecutionStatus } from '../../../../model/execution';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MatRadioChange } from '@angular/material/radio';
import { InstrumentationEnum, InstrumentationUse } from '../../../../model/instrumentationUse';
import { InstrumentationService } from '../../../../services/instrumentation.service';
import { Subject, takeUntil } from 'rxjs';
import { ValidatorSpecifics } from '../../../../model/validatorSpecific';

export class DataInstrumentalUsed {
  data: ExecutionQTestInstrumentalUsed;
  idStatus: number;
}
@Component({
    selector: 'app-execution-q-edit-test-instrumental-used',
    templateUrl: './execution-q-edit-test-instrumental-used.component.html',
    styleUrl: './execution-q-edit-test-instrumental-used.component.scss',
    standalone: false,
})
export class ExecutionQEditTestInstrumentalUsedComponent implements OnInit {

  instrumentationUse: InstrumentationUse[];
  showValidatorSpecifics = false;
  private destroy$ = new Subject<void>();
  private hasLoaded$ = new Subject<void>();
  constructor(
    private instrumentationService: InstrumentationService,
    private dialogRef: MatDialogRef<ExecutionQEditTestInstrumentalUsedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataInstrumentalUsed,
    private translate: TranslateService,
    public snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.showValidatorSpecifics = this.data.data.validator != null;

    if (!this.data.data.validator) {
      this.data.data.validator = new ValidatorSpecifics();
    }
    this.instrumentationUse = [];
    this.instrumentationService.findAllExecution().pipe(takeUntil(this.destroy$))
      .subscribe((data: InstrumentationUse[]) => this.instrumentationUse = data);

    const instr = this.instrumentationUse.find(i => i.id === this.data.data.idInstrumentation);
    if (instr != null) {
      this.configureInstrumentation(instr);
    } else if (this.data.data.idInstrumentation != null) {
      this.instrumentationService.findOne(this.data.data.idInstrumentation).pipe(takeUntil(this.hasLoaded$))
        .subscribe((ins: InstrumentationUse) => this.configureInstrumentation(ins));
    }
  }

  configureInstrumentation(instr: InstrumentationUse): void {
    this.showValidatorSpecifics = instr?.hasValidatorSpecifics;

    if (this.data.data.validator === null) {
      this.data.data.validator = new ValidatorSpecifics();
      this.data.data.validator.lowDesv = 1;
      this.data.data.validator.highDesv = 1;
      this.data.data.validator.verifDesv = 0.5;
      this.data.data.validator.minStability = 0.2;
    }
  }

  showValidator(): boolean {
    return this.showValidatorSpecifics;
  }

  onInstrumentationChange(event: MatRadioChange): void {
    const instr = this.instrumentationUse.find(i => i.id === event.value);

    this.showValidatorSpecifics = instr.hasValidatorSpecifics;

    if (this.showValidatorSpecifics) {
      const validator = new ValidatorSpecifics();
      validator.lowDesv = 1;
      validator.highDesv = 1;
      validator.verifDesv = 0.5;
      validator.minStability = 0.2;
      this.data.data.validator = validator;
    } else {
      this.data.data.validator = null;
    }
  }

  enableEditInstrumentationToUse(): boolean {
    const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

    return allowedStatuses.includes(this.data.idStatus);
  }

  canEditValidator(item: InstrumentationUse): boolean {
    const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

    return this.showValidator() && item.hasValidatorSpecifics && allowedStatuses.includes(this.data.idStatus);
  }

  onOkClick() {
    const errs = this.errors();
    if (errs.length === 0) {
      const use = this.instrumentationUse.find(e => e.id === this.data.data.idInstrumentation);
      this.data.data.translation = use.translation;
      this.dialogRef.close(this.data.data);
    } else {
      const error = errs.join('\n');
			this.snackBarService.sendError(error);
    }
     
  }

  errors(): string[] {
    let errs = [];

    if (!this.data.data.idInstrumentation) {
      errs.push(this.translate.instant("protocolEdit.instrumentationUse.error"));
    } else {
      if (this.data.data.idInstrumentation === InstrumentationEnum.VALIDATOR) {
        if (!this.data.data.validator) {
          errs.push(this.translate.instant(""));
        } else {
          if (!this.data.data.validator.lowTemp) {
            errs.push(this.translate.instant("protocolEdit.instrumentationUse.validator.lowTemp.error"));
          }

          if (!this.data.data.validator.lowDesv) {
            errs.push(this.translate.instant("protocolEdit.instrumentationUse.validator.highTemp.error"));
          }

          if (!this.data.data.validator.highTemp) {
            errs.push(this.translate.instant("protocolEdit.instrumentationUse.validator.verifTemp.error"));
          }

          if (!this.data.data.validator.minStabilityTime) {
            errs.push(this.translate.instant("protocolEdit.instrumentationUse.validator.minStabilityTime.error"));
          }
        }
      }
    }

    return errs;
  }

  onNoClick() {
    this.dialogRef.close(null);
  }
}
